<script setup>
import { ref } from 'vue'

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  defaultValue: {
    type: Array,
    default: () => [],
  },
  mode: {
    type: String,
    default: 'multiple',
  },
  showSearch: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  allowClear: {
    type: Boolean,
    default: false,
  },
  maxTagCount: {
    type: Number,
    default: 0,
  },
})

const emit = defineEmits([ 'deselect', 'blur', 'focus' ])
const isFocus = ref(false)
function onFocus() {
  isFocus.value = true
  emit('focus')
}

function onBlur(value) {
  isFocus.value = false
  emit('blur', value)
}

function onDeselect(args) {
  if (!isFocus.value) {
    emit('deselect', ...args)
  }
}

</script>

<template>
  <a-select 
    v-bind="{...$attrs, ...$props}"
    @focus="onFocus"
    @deselect="(...args) => onDeselect(args)"
    @blur="onBlur"
  />
</template>
